export const GET_USERS_LIST = 'GET_USERS_LIST';
export const CHANGE_USERS_LIST_PAGE = 'CHANGE_USERS_LIST_PAGE';
